/**
 * A client-side id for rows that arrive without one — SharePoint list rows and SAP info
 * codes. Only ever used for `trackBy`, never sent anywhere, so uniqueness within the
 * session is the whole requirement.
 *
 * Replaces Akita's `guid()`, which was `Math.random().toString(36).slice(2)` and, per its
 * own doc comment, "isn't a GUID".
 */
export const localId = (): string => crypto.randomUUID();
